const COLOR_PRIMARY = '#2470AF';
const COLOR_DARK_1 = '#2E3F5C';
const COLOR_DARK_2 = '#1E2A3D';
const COLOR_DARK_3 = '#222F44';
const COLOR_DARK_4 = '#192333';
const COLOR_DARK_5 = '#25344B';
const COLOR_WHITE = '#FFFFFF';
const COLOR_BLACK = '#000000';
const COLOR_GRAY_BASE = '#343E4F';
const COLOR_GRAY_900 = '#48566e';
const COLOR_LIGHT_GRAY = '#F0F2F5';
const COLOR_LIGHT_GRAY_2 = '#d7d8d9';
const COLOR_LIGHT = '#D3D9E2';
const COLOR_LIGHT_BLUE = '#EAF1F7';
const COLOR_BLUE = '#2470AF';
const COLOR_LOGO_ICON = '#175DFF';
const COLOR_LOGO_FONT = '#0B073B';
const COLOR_SCROLLBAR = '#1B5585';
const COLOR_OVERLAY = '#4E5C7366';

export {
  COLOR_PRIMARY,
  COLOR_DARK_1,
  COLOR_DARK_2,
  COLOR_DARK_3,
  COLOR_DARK_4,
  COLOR_DARK_5,
  COLOR_WHITE,
  COLOR_BLACK,
  COLOR_GRAY_BASE,
  COLOR_GRAY_900,
  COLOR_LIGHT_GRAY,
  COLOR_LIGHT_GRAY_2,
  COLOR_LIGHT,
  COLOR_LIGHT_BLUE,
  COLOR_BLUE,
  COLOR_LOGO_ICON,
  COLOR_LOGO_FONT,
  COLOR_SCROLLBAR,
  COLOR_OVERLAY,
};
